import { SidebarProvider } from "../shadcn/components/ui/Sidebar";
import { Topbar } from "../Component/dashboard/Topbar";
import { DashboardSidebar as Sidebar } from "../Component/SuperAdmin/Sidebar";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import MyProfile from "../Component/SuperAdmin/MyProfile/MyProfile";
import PostForm from "../Component/SuperAdmin/Properties&Services/PostForm";
import MyProperties from "../Component/SuperAdmin/Properties&Services/ServicesProperties";
import { Applications } from "../Component/SuperAdmin/Applications/Applications";
import Message from "../Component/dashboard/messages/Messages";
import { AccountingPage } from "../Component/dashboard/Accounting/AccountingPage";
import { HelpAndSupport } from "../Component/SuperAdmin/HelpSupport/HelpSupport";
import { IndustryRelations } from "../Component/serviceProvider dashboard/IndustryRelations/IndustryRelations";
import { Accounting } from "../Component/serviceProvider dashboard/Accounting/Accounting";
import PropertyForm from "../Component/dashboard/Propertyform/Propertyform";
import MyPropertiesServices from "../Component/RealEstateDashboard/MyProperties/MyProperties";
import ProfileForm from "../Component/RealEstateDashboard/MyProfile/MyProfile";
import { MessageBoard } from "../Component/SuperAdmin/messages/MessageBoard";
import { LiveChat } from "../Component/SuperAdmin/messages/LiveChat";
import Transportform from "../Component/SuperAdmin/Properties&Services/TransportForm";
import ServiceInfoform from "../Component/SuperAdmin/Properties&Services/ServiceInfoForm";
import FilledLeaseForm from "../Component/SuperAdmin/Applications/Filledleaseform";
import FilledRentalApplication from "../Component/SuperAdmin/Applications/Filledrentalform";
import { CorporateMessages } from "../Component/SuperAdmin/messages/CorporateMessages";
import Donations from "../Component/SuperAdmin/Donations/Donations";
import ReviewsPanel from "../Component/SuperAdmin/Reviews/Reviews";
import Notification from "../Component/Notification";

export function SuperAdmin() {
  const { section } = useParams();
  const [isOpen, setIsOpen] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth >= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <SidebarProvider className="">
      <div className="flex min-h-screen w-full">
        <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
        <div className={`flex-1 flex flex-col`}>
          <Topbar section={section} />
          <main className="flex-1 overflow-auto p-4">
            {section==="Notification"&&<Notification/>}
            {section === "My Profile" && <MyProfile />}
            {section === "services" && <PostForm />}
            {section === "properties" && <MyProperties />}
            {section === "applications" && <Applications />}
            {section === "messages" && <CorporateMessages />}
            {section === "accounting" && <Accounting />}
            {section === "Help & Support" && <HelpAndSupport />}
            {section === "Industry relations" && <IndustryRelations />}
            {section === "Donations" && <Donations />}
            {section === "Testimonials" && <ReviewsPanel />}

            {section === "propertyform" && <PropertyForm />}
            {section === "livechat" && <LiveChat />}

            {/* post a service form */}
            {section === "Property" && <PostForm />}
            {section === "Transportation" && <Transportform />}
            {section === "Service Information" && <ServiceInfoform />}
            {section === "Health Care"}

            {section === "filledlease" && <FilledLeaseForm />}
            {section === "filledrental" && <FilledRentalApplication />}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
